export default __webpack_public_path__ + "static/media/bag2.091039f7.jfif";